var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"s-pendant",class:{'pointer': !!_vm.link},attrs:{"src":_vm.src,"alt":"","width":"100%","height":"100%"},on:{"click":function($event){_vm.link ? _vm.handleClick : null}}})
}
var staticRenderFns = []

export { render, staticRenderFns }